/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap')

import { createApp, onMounted } from 'vue'
import { createVfm, ModalsContainer } from 'vue-final-modal'

import mitt from 'mitt'
import PopperIcon from "./components/PopperIcon.vue";
const emitter = mitt()

import '@splidejs/splide/dist/css/themes/splide-default.min.css'
import 'vue-final-modal/style.css'
// import '@vuepic/vue-datepicker/dist/main.css'
// import '@vueform/multiselect/themes/default.css'


// COMPONENTS
import JobFinder from './components/JobFinder.vue'
import TestimonialCarousel from './components/TestimonialCarousel.vue'
import GeneralCarousel from './components/GeneralCarousel.vue'
import MapSection from './components/MapSection.vue'
import ImageLightbox from './components/ImageLightbox.vue'
import FormMultiselect from './components/form/FormMultiselect.vue'
import FormDatepicker from './components/form/FormDatepicker.vue'
import FormFileUpload from './components/form/FormFileUpload.vue'
import FormMultiFileUpload from "./components/form/FormMultiFileUpload.vue";
import ModalCore from './components/modal/ModalCore.vue'


// BE napojenie
import TestimonialCarouselBE from "./components/BE/TestimonialCarouselBE.vue";
import MapSectionBE from "./components/BE/MapSectionBE.vue";
import Loader from "./components/modal/Loader.vue";
import DataChangeModal from "./components/modal/DataChangeModal.vue";
import JobFinderBE from "./components/BE/JobFinderBE.vue";

// GLOBAL EVENTS
window.flash = function (message, classes) {
	emitter.emit('flash', { message: message, classes: classes })
}

window.showModal = function (name) {
    emitter.emit('showModal', name)
}

window.setModalTitle = function (title) {
    window.clientZoneModalTitle = title
}

const vfm = createVfm()

const app = createApp({

    components: {
        JobFinder,
        TestimonialCarousel,
        GeneralCarousel,
        MapSection,
        ImageLightbox,
        FormMultiselect,
        FormDatepicker,
        FormFileUpload,
        FormMultiFileUpload,
        ModalsContainer,
        ModalCore,
        TestimonialCarouselBE,
        MapSectionBE,
        Loader,
        DataChangeModal,
        JobFinderBE,
        PopperIcon
    }
})

app.provide('emitter', emitter)
app.use(vfm)
app.mount('#app')
